import { useState, useEffect } from 'react';
import { X, Mail } from 'lucide-react';
import { supabase } from '../lib/supabase';
import EmailLinkModal from './EmailLinkModal';
import type { User } from '../lib/types';

const DISMISSED_KEY = 'email_banner_dismissed';

interface Props {
  userId?: number;
}

export default function EmailBanner({ userId }: Props) {
  const [dismissed, setDismissed] = useState(true);
  const [user, setUser] = useState<User | null>(null);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    if (!userId || userId <= 0) return;

    try {
      if (sessionStorage.getItem(DISMISSED_KEY) === '1') return;
    } catch {}

    supabase.from('users').select('id, email, display_name, first_name, last_name, username, is_guest').eq('id', userId).single()
      .then(({ data }) => {
        if (data && !data.email) {
          setUser(data as User);
          setDismissed(false);
        }
      });
  }, [userId]);

  if (dismissed || !user) return null;

  const handleDismiss = () => {
    setDismissed(true);
    try { sessionStorage.setItem(DISMISSED_KEY, '1'); } catch {}
  };

  return (
    <>
      <div className="email-banner">
        <Mail size={18} className="email-banner__icon" />
        <div className="email-banner__text">
          <span className="email-banner__title">Привяжите email</span>
          <span className="email-banner__subtitle">Чтобы входить через браузер без Telegram</span>
        </div>
        <button className="email-banner__action" onClick={() => setShowModal(true)}>
          Привязать
        </button>
        <button className="email-banner__close" onClick={handleDismiss}>
          <X size={16} />
        </button>
      </div>

      {showModal && (
        <EmailLinkModal
          user={user}
          onClose={() => setShowModal(false)}
          onLinked={() => { setShowModal(false); setDismissed(true); }}
        />
      )}
    </>
  );
}
